module.exports = __webpack_public_path__ + "static/img/image_recruit_09.a0059d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/join/image_recruit_09.png
// module id = LE5H
// module chunks = 10